import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import DateField from './DateField';
import { localizeSystemText } from '../../i18n/messages';
import LocalizedMessage from './LocalizedMessage';

function Input({ label, name, placeholder, error, value, type, className, readOnly, inputMode, autoComplete, pattern, maxLength, append, onBlur, onChange }) {
  const { t } = useTranslation();
  const translatedLabel = localizeSystemText(label, t);
  const translatedPlaceholder = localizeSystemText(placeholder, t);
  const isValid = e => (e ? "is-invalid" : "");
  return (
    <div className={`form-group ${className}`}>
      <span><strong>{translatedLabel}</strong></span>
      <div className="input-group mt-1">
        {type === 'textarea' && (
          <textarea
            name={name}
            className={`form-control ${isValid(error)}`}
            value={value}
            onChange={onChange}
            onBlur={onBlur}
            placeholder={translatedPlaceholder}
            readOnly={readOnly}
            aria-label={translatedLabel}
          />
        )}
        {(type === 'date' || type === 'datetime-local') && (
          <DateField
            type={type}
            name={name}
            className={`form-control ${isValid(error)}`}
            value={value}
            onChange={onChange}
            onBlur={onBlur}
            readOnly={readOnly}
            aria-label={translatedLabel}
          />
        )}
        {type !== 'textarea' && type !== 'date' && type !== 'datetime-local' && (
          <input
            type={type}
            name={name}
            className={`form-control ${isValid(error)}`}
            value={value}
            onChange={onChange}
            onBlur={onBlur}
            placeholder={translatedPlaceholder}
            readOnly={readOnly}
            inputMode={inputMode}
            autoComplete={autoComplete}
            pattern={pattern}
            maxLength={maxLength}
            aria-label={translatedLabel}
          />
        )}
        {append}
        <div className="invalid-feedback"><LocalizedMessage isError value={error} /></div>
      </div>
    </div>
  );
}

Input.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({ key: PropTypes.string.isRequired, params: PropTypes.object })]),
  value: PropTypes.string,
  type: PropTypes.string,
  className: PropTypes.string,
  readOnly: PropTypes.bool,
  inputMode: PropTypes.string,
  autoComplete: PropTypes.string,
  pattern: PropTypes.string,
  maxLength: PropTypes.number,
  append: PropTypes.node,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
};

Input.defaultProps = {
  label: "",
  placeholder: "",
  error: undefined,
  value: "",
  type: "text",
  className: "",
  readOnly: false,
  inputMode: undefined,
  autoComplete: undefined,
  pattern: undefined,
  maxLength: undefined,
  append: null,
  onBlur: () => {},
  onChange: () => {},
};

export default Input;
